import type { FaireProductEntity } from "../../entity_types/product";

export const pom_pom_3: FaireProductEntity = {
  token: "pom-pom-3",
  type: "product",
  name: "Popcorn, Classic",
  brandName: "Pom Pom Popcorn by Bessou",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/dbe19f177009d85bfe930db699a66933fa17b7d4e8d21fc65b9e97e51aa5843c.jpeg",
  priceDollars: 8,
  msrpDollars: 14,
  freeShipping: false,
  isBestseller: true,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
